export default {
  badge: 'Configurando',
  title: 'Termina de configurar tu restaurante',
  description: 'Faltan algunos pasos para que tu restaurante pueda activarse.',
  count: '{{done}} de {{total}} pasos completados',
  cta: 'Continuar configuración',
  done: {
    badge: 'Todo listo',
    title: 'Ya está todo listo',
    description: '{{partner}} activará tu restaurante.',
    fallback_partner: 'Tu proveedor',
  },
};
